<template>
  <v-dialog :value="value" max-width="480px" @input="$emit('input', $event)">
    <v-card v-if="value">
      <v-card-title class="headline">Kirim email uji</v-card-title>
      <v-card-text class="pb-0">
        <div class="bm-tiny mb-5">
          Mengirim contoh alert lewat n8n ke alamat ini. Tidak mengubah data dan tidak dicatat
          sebagai notifikasi.
        </div>
        <v-text-field
          v-model="to"
          label="Alamat tujuan"
          type="email"
          outlined
          dense
          autofocus
          hint="Satu alamat email."
          persistent-hint
          class="mb-4"
          @keyup.enter="send"
        ></v-text-field>
        <div class="bm-cap mb-1">CONTOH YANG DIKIRIM</div>
        <v-radio-group v-model="band" row dense hide-details class="mt-0">
          <v-radio label="Band merah" value="RED"></v-radio>
          <v-radio label="Band kuning" value="YELLOW"></v-radio>
          <v-radio label="Kembali hijau" value="GREEN"></v-radio>
        </v-radio-group>
        <div class="bm-tiny mt-2">
          Memakai PO contoh dengan angka tetap agar isi email bisa dicek.
        </div>
      </v-card-text>
      <v-card-actions class="px-4 pb-3">
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Batal</v-btn>
        <v-btn color="primary" :loading="sending" :disabled="!valid" @click="send">Kirim</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: "budget-test-email-dialog",
  props: { value: Boolean, defaultTo: { type: String, default: "" } },
  data: () => ({ to: "", band: "RED", sending: false }),
  computed: {
    valid() {
      return EMAIL.test((this.to || "").trim());
    },
  },
  watch: {
    value(v) {
      if (v && !this.to) this.to = this.defaultTo;
    },
  },
  methods: {
    async send() {
      if (!this.valid) return;
      this.sending = true;
      try {
        await this.$store.dispatch("budgetMonitor/sendTestEmail", {
          to: this.to.trim(),
          band: this.band,
        });
        this.$store.dispatch("toast", {
          type: "success",
          message: `Email uji dikirim ke ${this.to.trim()} lewat n8n.`,
        });
        this.$emit("input", false);
      } catch (e) {
        const status = e && e.response && e.response.status;
        const msg = e && e.response && e.response.data && e.response.data.message;
        this.$store.dispatch("toast", {
          type: "error",
          message:
            status === 502
              ? `n8n menolak: ${msg || "webhook gagal"}. Cek budget.mail.webhook-url di properties.`
              : msg || "Gagal mengirim email uji",
        });
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
